﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import Swiper from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/modules/navigation.min.css';
import 'swiper/modules/pagination.min.css';
import { Navigation, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import deepMerge from '@tk/utilities/tk.deep.merge';

export default class TKCarousel extends TKCustomElementFactory {
    options?: string;
    customOptions: object = {};
    loadedClassName: string;
    slider?: Swiper;

    constructor() {
        super();
        this.options = this.getAttribute('data-tk-carousel-options') || undefined;
        this.loadedClassName = this.getAttribute('data-tk-loaded-class-name') || 'tk-carousel--loaded';

        if (this.options) {
            this.customOptions = JSON.parse(this.options);
        }
    }

    connectedCallback(): void {
        this.mountCarousel();
    }

    mountCarousel(): void {
        const root = this.querySelector<HTMLElement>('[data-tk-carousel-root]');
        const prevButton = this.querySelector<HTMLElement>('[data-tk-carousel-prev]');
        const nextButton = this.querySelector<HTMLElement>('[data-tk-carousel-next]');
        const pagination = this.querySelector<HTMLElement>('[data-tk-carousel-pagination]');

        if (!root || !prevButton || !nextButton || !pagination) {
            console.error('TKCarousel: Required elements are missing in the DOM.');
            return;
        }

        const defaultOptions: SwiperOptions = {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
                disabledClass: 'tk-carousel__arrow--disabled',
                enabled: false,
            },
            pagination: {
                el: pagination,
                bulletClass: 'tk-carousel__pagination-page',
                bulletActiveClass: 'tk-carousel__pagination-page--active',
                clickable: true,
                enabled: false,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                    navigation: {
                        enabled: true,
                    },
                    pagination: {
                        enabled: true,
                    },
                },
            },
            on: {
                init: this.onCarouselReady.bind(this),
            },
        };

        const config = deepMerge(defaultOptions, this.customOptions);

        this.slider = new Swiper(root, config);
    }

    onCarouselReady(): void {
        this.classList.add(this.loadedClassName);
    }
}
